import type { PermissionCode, PermissionRequirement } from '@/shared/permissions';

/**
 * Staff permissions, mirroring the `company` domain of the platform access catalogue.
 *
 * <p>`employees.view` is the directory read tier added by plan-auth-001 Phase 3.1 (GAP F-9b). Before it
 * existed `employees.manage` was the only staff permission on the platform, so anyone who could *see* the
 * team could also suspend, remove and transfer ownership.
 */

/** See who works here. Grants the list and the per-employee detail read, nothing else. */
export const EMPLOYEES_VIEW: PermissionCode = 'employees.view';

/**
 * Administer people: invite, change a role, resend/revoke an invitation, suspend, restore, remove and
 * transfer ownership. Every mutating BFF endpoint requires exactly this.
 */
export const EMPLOYEES_MANAGE: PermissionCode = 'employees.manage';

/**
 * What opens the staff directory: either code.
 *
 * <p>`employees.manage` is listed alongside the read tier deliberately — the catalogue emits both at
 * ADMIN, but a principal resolved from the BFF's legacy role mapping holds only the manage code, and the
 * server accepts it for the two reads (`EmployeeControllerImpl.requireViewTenant`). Gating the SPA on the
 * view code alone would hide a screen the BFF would serve.
 */
export const EMPLOYEE_DIRECTORY_PERMISSION: PermissionRequirement = [EMPLOYEES_VIEW, EMPLOYEES_MANAGE];
